module.exports = __webpack_public_path__ + "static/media/texture (41).6a558564.jpg";